import { useEffect, useRef } from 'react';

/** The BOQ item editor shares the right panel's column, so opening it moves QuantisAI out of the split (edge-
 *  triggered, so QuantisAI can still be opened over an editor already open). Shell inspectors move it out
 *  themselves through showShellInspector. Once whatever displaced it has closed, QuantisAI comes back. */
export function SISplitRestorer({ split, parked, editorOpen, inspectorOpen, onPark, onRestore }: { split: boolean; parked: boolean; editorOpen: boolean; inspectorOpen: boolean; onPark: () => void; onRestore: () => void }) {
  const editorWasOpen = useRef(editorOpen);
  const seenOpen = useRef(false);
  useEffect(() => {
    const editorOpened = editorOpen && !editorWasOpen.current;
    editorWasOpen.current = editorOpen;
    if (editorOpened && split) { seenOpen.current = true; onPark(); return; }
    if (!parked) { seenOpen.current = false; return; }
    if (inspectorOpen) { seenOpen.current = true; return; }
    if (seenOpen.current) { seenOpen.current = false; onRestore(); }
  }, [split, parked, editorOpen, inspectorOpen, onPark, onRestore]);
  return null;
}
